import React from "react";
import Icon, { IconProps } from "~/common/Icons/Standard";
const buttonStyle = "bg-white border border-solid border-gray-600 cursor-pointer rounded-full flex-none p-0 w-8 h-8 group hidden sm:flex items-center justify-center hover:bg-gray-100 active:bg-gray-100";
const iconStyle = "h-4 w-2 fill-green-500 group-active:fill-green-700";

// remove the `name` from both because there is overlap/conlict
// ModalNavigationArrow does not require a name attribute &
// Icon get's passed a name attribute directly
type ResolvedProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "name"> & Omit<IconProps, "name">;
interface NavigationArrowButtonProps extends ResolvedProps {
  ariaLabel: string;
  buttonClassName?: string;
  showLeftSideShadow?: boolean;
  showRightSideShadow?: boolean;
  iconClassName?: string;
}
const ButtonComponent = ({
  ariaLabel = "",
  buttonClassName = "",
  iconClassName = "",
  onClick,
  id,
  showLeftSideShadow = false,
  showRightSideShadow = false
}: NavigationArrowButtonProps) => {
  return <button aria-label={ariaLabel} data-testid={id} className={`${buttonStyle} ${buttonClassName} ${showLeftSideShadow && "right-4"} ${showRightSideShadow && "left-4"}`} onClick={onClick} type="button" data-sentry-component="ButtonComponent" data-sentry-source-file="ModalNavigationArrow.tsx">
      <Icon className={`${iconStyle} ${iconClassName} select-none`} name="navigation-arrow" data-sentry-element="Icon" data-sentry-source-file="ModalNavigationArrow.tsx" />
    </button>;
};
const ModalNavigationArrow = (props: NavigationArrowButtonProps) => {
  const {
    buttonClassName = "",
    showLeftSideShadow = false,
    showRightSideShadow = false
  } = props;
  if (showLeftSideShadow || showRightSideShadow) return <div className={`bg-white border w-16 h-20 hidden sm:flex ${buttonClassName} ${showLeftSideShadow && "shadow-[rgba(0,0,15,0.5)_-12px_0px_8px_-10px] -right-4 sm:-right-8 lg:-right-16"} ${showRightSideShadow && "shadow-[rgba(0,0,15,0.5)_12px_0px_8px_-10px] -left-4 sm:-left-8 lg:-left-16"}`}>
        <ButtonComponent {...props} />
      </div>;
  return <ButtonComponent {...props} data-sentry-element="ButtonComponent" data-sentry-component="ModalNavigationArrow" data-sentry-source-file="ModalNavigationArrow.tsx" />;
};
export default ModalNavigationArrow;